import { ServiceType, ServiceTypeLabel } from './models';
import { servicesOrder } from './const';
import { ServiceOffering } from 'olo-service';

const SERVICE_TYPE_KEY_BASE = 'colo-service-type_';
const SERVICE_TYPE_DATA_KEY = 'colo-service-type-data_';
const TABLE_DETAILS_KEY = 'colo-table-details_';
const CHOSEN_SERVICE_TYPE_KEY='colo-chosen-service-type_';

export const serviceTypeKey = (merchantId: string) => `${SERVICE_TYPE_KEY_BASE}${merchantId}`;
export const serviceTypeDataKey = (merchantId: string) => `${SERVICE_TYPE_DATA_KEY}${merchantId}`;
export const tableDetailsKey = (merchantId?: string) => `${TABLE_DETAILS_KEY}${merchantId}`;
export const chosenServiceTypeKey = (merchantId? : string) => `${CHOSEN_SERVICE_TYPE_KEY}${merchantId}`;

export const getDefaultServiceType = (serviceTypes: ServiceTypeLabel[]) => {
  return serviceTypes.length !== 0
    ? serviceTypes.find((service) => service.name === ServiceType.PICKUP) || serviceTypes[0]
    : undefined;
};

export const getInitialServiceType = (hasDineInQueryParam: boolean, defaultServiceType: ServiceTypeLabel | undefined) => {
  return hasDineInQueryParam ? ServiceType.DINE_IN : defaultServiceType?.name;
};

export const getSortedServices = (services: ServiceOffering[]) => {
  return services && [...services].sort((a, b) => servicesOrder[a.type] - servicesOrder[b.type]);
};
